import { onlyCallFnOnceWhilePreviousCallIsPending } from "libs/promise-utils";
import { withActionContext, write } from "./write";
import * as actions from "libs/actions";

export const toggleFocusMode = onlyCallFnOnceWhilePreviousCallIsPending(
  withActionContext(
    async (
      context,
      environment,
      props: {
        enableFocusMode: boolean;
      },
    ) => {
      const { currentUserId } = context;
      const [originalSettings] = await context.environment.loader.getRecord("user_settings", currentUserId);

      return {
        forward: async () => {
          const hasTheUserEverEnabledFocusModeBefore = !!originalSettings?.settings.focus_mode_exceptions;

          if (hasTheUserEverEnabledFocusModeBefore) {
            const action = await actions.toggleFocusMode.toggleFocusMode.action(props, context);

            await write(environment, { action });
          } else {
            // If the user has never enabled focus mode before,
            // we take them to the focus mode section of the
            // settings so that they can learn more about it
            // and do any initial setup that's necessary.
            await environment.router.navigate("/settings#focus-mode");
          }
        },
        backward: async () => {
          const action = await actions.toggleFocusMode.toggleFocusMode.action(
            { enableFocusMode: originalSettings?.settings.enable_focus_mode ?? false },
            context,
          );

          await write(environment, { action });
        },
      };
    },
  ),
);
